/**
 * @generated SignedSource<<ccb5dc3c39166913896f27c66700f9da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "accountId"
      }
    ],
    "kind": "ObjectValue",
    "name": "condition"
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "PS_ORDER_ASC"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "psId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "psStatus",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "declineCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastDeclineReason",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastDeclineChargeAmount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResellerPaymentSourceIssueFetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PaymentSourceTsConnection",
        "kind": "LinkedField",
        "name": "allPaymentSourceTs",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PaymentSourceT",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResellerPaymentSourceIssueFetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PaymentSourceTsConnection",
        "kind": "LinkedField",
        "name": "allPaymentSourceTs",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PaymentSourceT",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e4b12bf29f5064f76bf7e0390de62c12",
    "id": null,
    "metadata": {},
    "name": "ResellerPaymentSourceIssueFetchQuery",
    "operationKind": "query",
    "text": "query ResellerPaymentSourceIssueFetchQuery(\n  $accountId: UUID\n) {\n  allPaymentSourceTs(condition: {accountId: $accountId}, orderBy: PS_ORDER_ASC) {\n    totalCount\n    nodes {\n      psId\n      psStatus\n      declineCount\n      lastDeclineReason\n      lastDeclineChargeAmount\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "7c86fbaed03069bcc0f243778813ab26";

module.exports = node;
